import {Howl} from 'howler'
import handleAudioLoadError from '../utils/handleAudioLoadError'
import handleAudioPlayError from '../utils/handleAudioPlayError'

const howl = new Howl({
  src: ['/sounds/toggle-on.webm', '/sounds/toggle-on.mp3'],
  preload: true,
  onloaderror: handleAudioLoadError,
  onplayerror: handleAudioPlayError,
})

export default howl
